import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function getFieldLabel(name, t) {
    switch (name) {
        case 'typeLabelPL':
            return t('product_category_name_pl');
        case 'typeLabelEN':
            return t('product_category_name_en');
        default:
            return name;
    }
}
function getFieldError(name, form, t) {
    var _a, _b;
    if (name === 'typeLabelPL')
        return !((_a = form.typeLabelPL) === null || _a === void 0 ? void 0 : _a.trim()) ? t('required_field') : null;
    if (name === 'typeLabelEN')
        return !((_b = form.typeLabelEN) === null || _b === void 0 ? void 0 : _b.trim()) ? t('required_field') : null;
    return null;
}
function useProductCategoryValidation(form, t) {
    const validatedFields = useMemo(() => ['typeLabelPL', 'typeLabelEN'], []);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, form, t), (field) => getFieldLabel(field, t));
}
export default useProductCategoryValidation;
